<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <video ref="videoRef" width="320" height="240" autoplay muted playsinline></video>
      <div class="decoded-code" v-if="decodedCode">
        Código lido: {{ decodedCode }}
      </div>
      <div class="buttons">
        <button class="btn btn-primary" :disabled="!decodedCode" @click="locateProduct">
          Localizar Produto
        </button>
        <button class="btn btn-secondary close-btn" @click="closeModal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick, watch } from "vue";
import { BrowserMultiFormatReader } from "@zxing/browser";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "locate"],
  setup(props, { emit }) {
    const decodedCode = ref("");
    const videoRef = ref(null);
    let codeReader = null;

    const startScanner = async () => {
      if (!videoRef.value) return;

      codeReader = new BrowserMultiFormatReader();
      try {
        await codeReader.decodeFromVideoDevice(null, videoRef.value, (result, err) => {
          if (result) {
            decodedCode.value = result.getText();
          }
          if (err && err.name !== "NotFoundException") {
            console.error("Erro ao ler código:", err);
          }
        });
      } catch (e) {
        console.error("Erro ao iniciar câmera:", e);
      }
    };

    const stopScanner = () => {
      if (codeReader) {
        if (typeof codeReader.reset === "function") {
          codeReader.reset();
        }
        if (videoRef.value && videoRef.value.srcObject) {
          const stream = videoRef.value.srcObject;
          const tracks = stream.getTracks();
          tracks.forEach((track) => track.stop());
          videoRef.value.srcObject = null;
        }
        codeReader = null;
      }
    };

    const locateProduct = () => {
      if (decodedCode.value) {
        emit("locate", decodedCode.value);
      }
    };

    const closeModal = () => {
      decodedCode.value = "";
      stopScanner();
      emit("close");
    };

    watch(
      () => props.isOpen,
      async (isOpen) => {
        if (isOpen) {
          await nextTick();
          startScanner();
        } else {
          stopScanner();
        }
      }
    );

    onMounted(async () => {
      if (props.isOpen) {
        await nextTick();
        startScanner();
      }
    });

    onBeforeUnmount(() => {
      stopScanner();
    });

    return {
      decodedCode,
      videoRef,
      locateProduct,
      closeModal,
    };
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 1rem;
  border-radius: 0.5rem;
  width: 320px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.decoded-code {
  margin-top: 1rem;
  font-weight: bold;
  text-align: center;
}

.buttons {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.close-btn {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}
</style>
